import resultFactory from '~/utils/resultFactory'

export const state = () => ({
  txtTicketHistoryUrl: '/api/lr/ticket/browser/history',
  apiUrl: {
    log_stat: '/api/lr/prism/log/{display_id}/stat',
    log_result: '/api/lr/prism/log/{display_id}/result',
    log_message_info: '/api/lr/prism/log/message/info',
    log_save: '/api/lr/prism/log/{display_id}/save'
  },
  eventCodes: [],
  eventConfig: [],
  eventLevelTypes: [],
  search: {
    id: '',
    page_num: 1,
    isFirst: true
  },
  searchData: {
    log_type: '',
    stime: '',
    etime: '',
    total_rows: 10000,
    page_rows: 1000,
    order_by: 'desc',
    filters: []
  },
  searchState: {
    status: 'INIT', // 초기 단계: INIT, 추이 검색 중: SEARCHING_TREND_LOG, 로그 검색 중: SEARCHING_LOG, 검색 중지 요청 중: REQUEST_STOP, 로그 검색이 중지 됨: STOPPED, 로그 검색 완료: DONE
    progress: 0,
    searched_cnt: 0
  },
  // 필터 key 변경
  filterKey: {
    // [장비 이름, 티켓 이름, 발생 시간, 발생 기준, 티켓 상태, 발생 등급, 접수자, 종료자]
    ticket_browser_device_uname: 'ticket_browser_device_uname', // 티켓 이름
    ticket_browser_ticket_uname: 'ticket_browser_ticket_uname', // 티켓 이름
    ticket_browser_ticket_status: 'ticket_browser_ticket_status', // 티켓 상태
    ticket_browser_occur_grade: 'ticket_browser_occur_grade', // 발생 등급
    ticket_browser_receptor_id: 'ticket_browser_receptor_id' // 접수자

  },
  // data
  dataList: [],
  eventErrorMessage: '',
  menuData: [],
  resultType: [
    {value: '1', label: '성공'},
    {value: '0', label: '실패'}
  ]
})
export const mutations = {
  errorSearch (state) { // datalist 초기화
    state.dataList = []
  },
  mutGetSearchState (state, payload) { // page set
    state.searchState.searched_cnt = payload[0].cnt
    state.search.page_num = 1
  },
  getTicketHistoryDataAction: (state, data) => {
    _.forEach(data, (item) => {
      item.occurTerm = item.ticket_config_occur_type === 1 ? '실시간' : item.ticket_config_occur_term + '분 동안' + item.ticket_config_occur_cnt + '회 발생'
    })
    state.dataList = _.cloneDeep(data)
  },
  setEventLevelList (state, payload) { // need to check
    if (payload.length > 0) {
      const typeColor = {}
      _.forEach(payload, (item) => {
        typeColor[`${item.event_level_type}`] = item.event_level_color
      })
      state.eventLevelTypes = typeColor
    }
  },
  mutEventMessageInfo (state, payload) {
    state.eventCodes = payload
  },
  mutEventMessageInfoDetail (state, payload) {
    state.eventConfig = payload
  },
  mutEventErrorMessage (state, payload) {
    state.eventErrorMessage = payload
  }
}
export const actions = {
  // Ticket Browser History 목록 COUNT 조회
  async getSearchState ({commit, state}) { // 조건에 맞게 검색 Request 를 날리고, 그 결과로 cnt 를 가져옴.
    try {
      const req = {ticket_browser_start_dt: state.searchData.stime, ticket_browser_end_dt: state.searchData.etime}
      state.searchData.filters.forEach(item => {
        const key = state.filterKey[item.key]
        const codesD = (item.code[item.key] !== undefined) ? item.code[item.key] : item.code
        if (typeof key !== 'undefined') {
          const listKey = `${key}_list`
          if (key === 'audit_log_result_type') {
            req[key] = parseInt(codesD[0])
          } else {
            req[listKey] = codesD.map(x => {
              return isNaN(x) ? x : parseInt(x)
            })
          }

          if (item.key !== 'admin_login_ip') {
            req[`${key}_not_yn`] = (item.is_not) ? 1 : 0
          }
        }
      })
      const data = await this.$axios.$post(`${state.txtTicketHistoryUrl}/stat`, req, {loading: false, successAlert: false})
      return resultFactory(commit, {length: null, data: data, action: 'mutGetSearchState', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // Ticket Browser History 목록 조회
  async getSearchResult ({commit, state}) {
    const req = {
      order_by: state.searchData.order_by,
      page_cnt: state.searchData.page_rows,
      page_pos: (state.search.page_num - 1)
    }
    req.ticket_browser_start_dt = state.searchData.stime
    req.ticket_browser_end_dt = state.searchData.etime

    state.searchData.filters.forEach(item => {
      const key = state.filterKey[item.key]
      const codesD = (item.code[item.key] !== undefined) ? item.code[item.key] : item.code
      if (typeof key !== 'undefined') {
        const listKey = `${key}_list`
        if (key === 'audit_log_result_type') {
          req[key] = parseInt(codesD[0])
        } else {
          req[listKey] = codesD.map(x => {
            return isNaN(x) ? x : parseInt(x)
          })
        }

        if (item.key !== 'admin_login_ip') {
          req[`${key}_not_yn`] = (item.is_not) ? 1 : 0
        }
      }
    })

    try {
      const data = await this.$axios.$post(state.txtTicketHistoryUrl, req, {loading: false, successAlert: false})
      return resultFactory(commit, {length: null, data: data, action: 'getTicketHistoryDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 이벤트 레벨별 색상
  async getEventLevelType ({commit}) {
    try {
      const {code, result} = await this.$axios.$get('/api/sm/event-level')
      if (code === 'ok') {
        commit('setEventLevelList', result)
        return result
      } else {
        commit('mutEventErrorMessage', result.msg)
        return []
      }
    } catch (e) {
      commit('mutEventErrorMessage', e.message)
      return []
    }
  },
  async getTamsFilterDatas ({commit}) {
    try {
      const {code, result} = await this.$axios.$get('/api/sm/devices', { params: {device_id: 2} })
      if (code === 'ok') {
        const tamsDataArr = []
        _.forEach(result, (d) => {
          d.value = `${d.device_id}`
          tamsDataArr.push(d)
        })
        return tamsDataArr
      } else {
        return []
      }
    } catch (e) {
      commit('mutEventErrorMessage', e.message)
      return []
    }
  },
  async getAdminFilterDatas ({commit}) {
    try {
      const {code, result} = await this.$axios.$get('/api/lr/prism/log/admin-filter')
      if (code === 'ok') {
        const adminDataArr = []
        _.forEach(result, (d) => {
          d.value = `${d.admin_id}`
          adminDataArr.push(d)
        })
        return adminDataArr
      } else {
        return []
      }
    } catch (e) {
      commit('mutEventErrorMessage', e.message)
      return []
    }
  },
  async acsEventMessageInfo ({commit, state}) {
    try {
      const apiUrl = `${state.apiUrl.log_message_info}/basic`
      const res = await this.$axios.$get(apiUrl, {}, {loading: false, successAlert: false})
      if (res.code === 'ok') {
        commit('mutEventMessageInfo', res.result.event)
        return res.result.event
      } else {
        commit('mutEventErrorMessage', res.msg)
      }
    } catch (e) {
      commit('mutEventErrorMessage', e.message)
      return []
    }
  },
  async acsEventMessageInfoDetail ({commit, state}) {
    try {
      const apiUrl = `${state.apiUrl.log_message_info}/detail`
      const res = await this.$axios.$get(apiUrl, {}, {loading: false, successAlert: false})
      if (res.code === 'ok') {
        commit('mutEventMessageInfoDetail', res.result.event)
        return res.result.event
      } else {
        commit('mutEventErrorMessage', res.msg)
      }
    } catch (e) {
      commit('mutEventErrorMessage', e.message)
      return []
    }
  }
}
export const getters = {}
export const strict = false
